module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-modal', {
    attrs: {
      "visible": true,
      "title": _vm.title,
      "disableOk": false,
      "disablePreview": false
    }
  }, [_c('div', {
    staticClass: "content",
    class: [_vm.showPreview ? 'is-hidden' : ''],
    attrs: {
      "id": "modal-edit-content"
    }
  }, [_c('p', {
    staticClass: "control"
  }, [(_vm.isSubslide) ? _c('span', {
    staticClass: "select mode-select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.insertMode),
      expression: "insertMode"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.insertMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("Imagem")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Video")])])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editLanguage),
      expression: "editLanguage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.editLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language) {
    return _c('option', {
      domProps: {
        "value": language.slug
      }
    }, [_vm._v(_vm._s(language.name))])
  }))])]), _vm._v(" "), _vm._l((_vm.languageList), function(language) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (language.slug === _vm.editLanguage),
        expression: "language.slug === editLanguage"
      }],
      staticClass: "localization columns"
    }, [_c('div', {
      staticClass: "column column-quill is-12"
    }, [_c('p', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s('Descrição [' + language.name + ']'))]), _vm._v(" "), _c('quill', {
      ref: 'q1' + language.slug,
      refInFor: true,
      attrs: {
        "options": _vm.quillOptions
      }
    })], 1), _vm._v(" "), (_vm.showPlusDetail) ? _c('p', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v(_vm._s('Mais Detalhes [' + language.name + ']'))]), _vm._v(" "), _c('quill', {
      ref: 'q2' + language.slug,
      refInFor: true,
      attrs: {
        "options": _vm.quillOptions
      }
    })], 1) : _vm._e()])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSubslide || (_vm.isSubslide && _vm.insertMode === 1)),
      expression: "!isSubslide || (isSubslide && insertMode === 1)"
    }],
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Foreground 1 "), _c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.foreground1Text))])]), _vm._v(" "), (!_vm.newForeground1 && _vm.slide.foreground_image_1) ? _c('figure', {
    staticClass: "image is-16by9 slide-image fake-dropzone"
  }, [_c('img', {
    attrs: {
      "src": _vm.slide.foreground_image_1
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove",
    on: {
      "click": function($event) {
        _vm.showDropzone('foreground1')
      }
    }
  }, [_vm._v("Remover")])]) : _c('p', {
    staticClass: "control"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom",
    attrs: {
      "id": "slideForeground1",
      "url": _vm.dropzoneUploadUrl + '&type=' + _vm.foreground1Type,
      "thumbnail-width": 286,
      "thumbnail-height": 161,
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadForeground1,
      "vdropzone-removedfile": _vm.removeForeground1
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isSubslide || (_vm.isSubslide && _vm.insertMode === 1)),
      expression: "!isSubslide || (isSubslide && insertMode === 1)"
    }],
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Foreground 2 "), _c('span', {
    staticClass: "font-weight-light"
  }, [_vm._v(_vm._s(_vm.foreground2Text))])]), _vm._v(" "), (!_vm.newForeground2 && _vm.slide.foreground_image_2) ? _c('figure', {
    staticClass: "image  slide-image fake-dropzone"
  }, [_c('img', {
    attrs: {
      "src": _vm.slide.foreground_image_2
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "dz-remove",
    on: {
      "click": function($event) {
        _vm.showDropzone('foreground2')
      }
    }
  }, [_vm._v("Remover")])]) : _c('p', {
    staticClass: "control"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom",
    attrs: {
      "id": "slideForeground2",
      "url": _vm.dropzoneUploadUrl + '&type=' + _vm.foreground2Type,
      "thumbnail-width": 286,
      "thumbnail-height": 161,
      "acceptedFileTypes": "image/*"
    },
    on: {
      "vdropzone-success": _vm.successUploadForeground2,
      "vdropzone-removedfile": _vm.removeForeground2
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSubslide && _vm.insertMode === 2),
      expression: "isSubslide && insertMode === 2"
    }],
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Foreground 1")]), _vm._v(" "), (!_vm.newForegroundVideo && _vm.slide.foreground_image_1) ? _c('figure', {
    staticClass: "image fake-dropzone-video"
  }, [_c('video', {
    attrs: {
      "width": "100%",
      "height": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.slide.foreground_image_1,
      "type": "video/mp4"
    }
  }), _vm._v("\n            Your browser does not support the video tag.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "dz-remove",
    on: {
      "click": function($event) {
        _vm.showDropzone('foreground1')
      }
    }
  }, [_vm._v("Remover")])]) : _c('p', {
    staticClass: "control"
  }, [_c('dropzone', {
    staticClass: "marginless-dropzone dz-dom",
    attrs: {
      "id": "slideForegroundVideo",
      "url": _vm.dropzoneUploadUrl + '&type=5',
      "thumbnail-width": 286,
      "thumbnail-height": 161,
      "acceptedFileTypes": ".mp4"
    },
    on: {
      "vdropzone-success": _vm.successUploadForeground1,
      "vdropzone-removedfile": _vm.removeForeground1
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-half"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Posição")]), _vm._v(" "), _c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slide.order),
      expression: "slide.order"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slide.order = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.orderOptions), function(order) {
    return _c('option', {
      domProps: {
        "value": order.id
      }
    }, [_vm._v(_vm._s(order.value))])
  }))])])])], 2), _vm._v(" "), (_vm.previewReady) ? _c('div', {
    staticClass: "content",
    class: [_vm.showPreview ? '' : 'is-hidden'],
    attrs: {
      "id": "modal-preview-content"
    }
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.previewLanguage),
      expression: "previewLanguage"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.previewLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language) {
    return _c('option', {
      domProps: {
        "value": language.slug
      }
    }, [_vm._v(_vm._s(language.name))])
  }))])]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentDetail),
      expression: "currentDetail"
    }],
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-primary",
    class: {
      'is-outlined': _vm.showDetail
    },
    on: {
      "click": function($event) {
        _vm.showDetail = !_vm.showDetail
      }
    }
  }, [_vm._v("\n          Detalhes\n        ")])])]), _vm._v(" "), _c('parallax-composite', {
    attrs: {
      "background1": _vm.menuBackground1 ? 'url(' + _vm.menuBackground1 + ')' : null,
      "background2": _vm.menuBackground2 ? 'url(' + _vm.menuBackground2 + ')' : null,
      "foreground1": _vm.slide.foreground_image_1 ? 'url(' + _vm.slide.foreground_image_1 + ')' : null,
      "foreground2": _vm.slide.foreground_image_2 ? 'url(' + _vm.slide.foreground_image_2 + ')' : null,
      "insertMode": _vm.insertMode,
      "backgroundColor": _vm.menu.background_color,
      "textboxColor": _vm.menu.textbox_color,
      "textColor": _vm.menu.text_color,
      "description": _vm.currentDescription,
      "plusDetail": _vm.currentDetail,
      "showDetail": _vm.showDetail,
      "slide": _vm.slide.order - 1,
      "category": _vm.slide.slide_category_id,
      "editWidth": _vm.previewImageWidth
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-text-box",
    style: ({
      background: this.menu.textbox_color
    })
  }, [_c('div', {
    staticClass: "preview-description"
  })]), _vm._v(" "), _c('div', {
    staticClass: "preview-slide-name-warning"
  }, [_c('span', {
    staticClass: "preview-warning-text"
  }, [_c('b', [_vm._v("Aviso:")]), _vm._v(" " + _vm._s(_vm.previewWarning))])])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39342a8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slide/SlideEditModal.vue
// module id = 312
// module chunks = 1